/// <amd-module name="VSS/Redux/Modules/VSSPageData/VSSPageDataSaga" />
import { effects, SagaIterator } from "redux-saga";
import { IVssPageContext } from "VSS/Platform/Context";
import { IPageData, IVssPageService } from "VSS/Platform/Page";
import { VSSPageDataActions } from "./VSSPageDataActions";

export function* vssPageDataSaga(): SagaIterator {
    yield effects.call(initialize);
}

export function* initialize() {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const vssPageService: IVssPageService = (yield effects.call([pageContext, pageContext.getService], "IVssPageService")) as any;
    const vssPageData: IPageData | undefined = (yield effects.call([vssPageService, vssPageService.getData])) as any;

    if (vssPageData) {
        yield effects.put(VSSPageDataActions.initialize(vssPageData));
    }
}
